import { render, staticRenderFns } from "./AssignmentCard.vue?vue&type=template&id=6f4ec540&scoped=true&"
import script from "./AssignmentCard.vue?vue&type=script&lang=ts&"
export * from "./AssignmentCard.vue?vue&type=script&lang=ts&"
import style0 from "./AssignmentCard.vue?vue&type=style&index=0&id=6f4ec540&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4ec540",
  null
  
)

export default component.exports